import { InjectionToken, TemplateRef, WritableSignal } from '@angular/core';

/**
 * Optionele content-slot links bovenaan in de panel-topbar (op dezelfde
 * verticale hoogte als de pin/close/extra-actions rechts). Wordt door de
 * content-component (of zijn wrapper) gevuld met een `TemplateRef` — de
 * {@link FloatingPanelHostComponent} rendert dat via `ngTemplateOutlet`.
 *
 * Praktisch gebruik: een korte secundaire identificatie van het panel die de
 * gewone heading-tekst niet mag verdringen (bv. de circuit-vermelding voor
 * een gate-info dialog).
 */
export const FLOATING_PANEL_TOPBAR_LEFT = new InjectionToken<
  WritableSignal<TemplateRef<unknown> | null>
>('FLOATING_PANEL_TOPBAR_LEFT');
